<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.157898 9.49289C0.157898 10.0374 0.599327 10.4788 1.14386 10.4788L7.55258 10.4788L7.55258 16.8876C7.55258 17.4321 7.99401 17.8735 8.53854 17.8735L9.5245 17.8735C10.069 17.8735 10.5105 17.4321 10.5105 16.8876L10.5105 10.4788L16.9192 10.4788C17.4637 10.4788 17.9051 10.0374 17.9051 9.49289L17.9051 8.50693C17.9051 7.9624 17.4637 7.52097 16.9192 7.52097L10.5105 7.52097L10.5105 1.11225C10.5105 0.56771 10.069 0.126289 9.5245 0.126289L8.53854 0.126289C7.99401 0.126289 7.55258 0.567711 7.55258 1.11225L7.55258 7.52097L1.14386 7.52098C0.599326 7.52098 0.157898 7.9624 0.157898 8.50693L0.157898 9.49289Z"
      fill="rgb(var(--v-theme-primary))"
    />
  </svg>
</template>
